<template>
  <div class="container">
    <div style="display:none">{{announcementIndex}}</div>
    <div v-if="list.length < 1" class="none">暂无数据</div>
    <div v-else>
      <div class="announcement" v-for="item in list" :key="item.id">
        <div class="announcement-item" @click="toDetail(item)">
          <div class="title">{{ item.title }}</div>
          <div class="date">{{ item.publicTime.substring(0, 10) }}</div>
        </div>
      </div>
    </div>
    <Pagination
      :total="paginationParam.total"
      :page.sync="paginationParam.pageIndex"
      :limit.sync="paginationParam.pageSize"
      @pagination="getListData"
    />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  components: { Pagination },
  data() {
    return {
      paginationParam: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      list: [],
      formInfo: {
        title: "",
        topStatus: "",
        beginTime: "",
        endTime: "",
      },
      Total: 0,
    };
  },
  computed: {
    announcementIndex() {
      let index = this.$route.query.index
      this.getListData()
      return index
    }
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        name: "announcementDetail",
        query: { id: item.id, index: this.$route.query.index },
      });
    },
    getListData() {
      let index = this.$route.query.index
      let configTypeKey = 1
      // 1 新闻动态2 项目公告3 政策法规4 成交公告5 采购公告6 合作招商
      switch(Number(index)) {
        case 4:
          configTypeKey = 3
          break;
        case 5:
          configTypeKey = 2
          break;
        case 6:
          configTypeKey = 4
          break;
        case 8:
          configTypeKey = 5
          break;
        case 9:
          configTypeKey = 6
          break;
        default:
         configTypeKey = 1
          break;
      }
      let data = {
        pageNumber: this.paginationParam.pageIndex,
        pageSize: this.paginationParam.pageSize,
        userId: this.$store.state.userInfo.id,
        areaConfigId: this.$store.state.cityArea.areaConfigId,
        systemConfigName: "rural",
        configTypeKey: configTypeKey,
        title: this.$route.query.search
      };
      this.$api.trade.getProjectList(data).then((res) => {
        this.list = res.data;
        this.paginationParam.total = res.total;
      });
    },
  },
  mounted() {
    this.getListData();
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 1120px;
  margin: 0 auto;
  padding: 0 40px;
  background: #fff;
  min-height: 680px;
  position: relative;
  .none {
    font-size: 20px;
    text-align: center;
    padding-top: 150px;
  }
  .announcement {
    padding: 15px 0;
    border-bottom: 1px solid #ebecef;
    cursor: pointer;
    &:last-child {
      border: none;
    }
    .announcement-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      line-height: 30px;

      &::before {
        content: " ";
        width: 4px;
        height: 4px;
        // background: linear-gradient(
        //   135deg,
        //   rgba(255, 112, 103, 1) 0%,
        //   rgba(239, 81, 71, 1) 100%
        // );
        border: 2px solid #c5323e;
        border-radius: 50%;
        position: absolute;
        left: -20px;
      }
      .title {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #394259;
        width: 680px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .date {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #A8AAAE;
      }
    }
  }
  .el-pagination {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>